import BaseScrollContainer from '~/components/Layout/BaseScrollContainer.vue';
import LeafIcon from '~/components/ui/LeafIcon.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'BlockImagesTextTemplate',
  components: {
    LeafIcon: LeafIcon,
    AzImg: AzImg,
    BaseScrollContainer: BaseScrollContainer
  },
  props: {
    title: String,
    text: String,
    classes: Object,
    pictos: Array,
    backgroundWhite: Boolean,
    isOverlay: Boolean,
    bottomContent: Boolean,
    leafListOption: Boolean,
    isPageAdvice: Boolean,
    isRecipePage: Boolean,
    isHomePage: Boolean
  },
  setup: function setup(props) {
    var isContentExpanded = inject('isContentExpanded', false);
    var hasCarousel = inject('hasCarousel', true);
    var getTwicPicImg = function getTwicPicImg(image) {
      var _image$fields, _image$fields$file;
      var url = (image === null || image === void 0 ? void 0 : (_image$fields = image.fields) === null || _image$fields === void 0 ? void 0 : (_image$fields$file = _image$fields.file) === null || _image$fields$file === void 0 ? void 0 : _image$fields$file.url) || '';
      return url;
    };
    var isBigImgClass = computed(function () {
      return props.classes.image == 'image-big';
    });
    var isBigLeafTitle = computed(function () {
      return props.classes.title == 'big-leaf-title';
    });
    return {
      isContentExpanded: isContentExpanded,
      isBigImgClass: isBigImgClass,
      getTwicPicImg: getTwicPicImg,
      isBigLeafTitle: isBigLeafTitle,
      hasCarousel: hasCarousel
    };
  }
});